if ( typeof window.cartSectionUrl !== 'function' ) {
	// Same page, plus section_id — built from the full URL so params the page
	// depends on (preview_theme_id above all) survive the request.
	window.cartSectionUrl = (sectionId) => {
		const url = new URL(window.location.href);
		url.searchParams.set('section_id', sectionId);
		return url.toString();
	};
}

if ( typeof window.cartScopeFor !== 'function' ) {
	// In the theme editor the cart drawer is rendered on the cart page too, and
	// it comes first in the DOM — so there are two #AjaxCartForm and two
	// #AjaxCartSubtotal, and getElementById always answers with the drawer's.
	// Every lookup has to be scoped to the cart that is actually being changed.
	window.cartScopeFor = (cartForm) => {
		if ( ! cartForm ) return document;
		return cartForm.closest('.' + (window.KT_PREFIX || '') + 'cart-section')
			|| cartForm.closest('sidebar-drawer')
			|| document;
	};

	window.cartSubtotalFor = (cartForm) => {
		return window.cartScopeFor(cartForm).querySelector('#AjaxCartSubtotal')
			|| document.getElementById('AjaxCartSubtotal');
	};
}

if ( typeof window.renderHelperCart !== 'function' ) {
	window.renderHelperCart = (text, targetForm) => {

		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		const newCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
		const newCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
		const cartItems = targetForm || document.getElementById('AjaxCartForm');

		// Say which part was missing: callers reconcile from the cart JSON and
		// fall back when this throws, and a silent TypeError told nobody why.
		if ( ! newCartForm || ! newCartSubtotal ) {
			throw new Error('helper-cart response is missing the cart markup');
		}
		if ( ! cartItems ) {
			throw new Error('no cart form on this page to refresh');
		}

		cartItems.innerHTML = newCartForm.innerHTML;
		if ( typeof cartItems.ajaxifyCartItems === 'function' ) {
			cartItems.ajaxifyCartItems();
		}

		const cartCount = cartItems.querySelector('[data-cart-count]');
		const cartTotal = cartItems.querySelector('[data-cart-total]');
		if ( cartCount ) {
			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartCount.textContent;
			});
		}
		if ( cartTotal ) {
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartTotal.textContent;
			});
		}

		const subtotal = window.cartSubtotalFor(cartItems);
		if ( subtotal ) {
			subtotal.innerHTML = newCartSubtotal.innerHTML;
		}

		const cartScope = window.cartScopeFor(cartItems);
		const count = Number.parseInt(cartCount?.textContent, 10);
		const emptyClass = `${window.KT_PREFIX || ''}cart-section--empty`;
		if ( cartScope.matches?.(`.${window.KT_PREFIX || ''}cart-section`) && Number.isFinite(count) ) {
			cartScope.classList.toggle(emptyClass, count === 0);
		}

		return sectionInnerHTML;

	};

	window.addEventListener('pageshow', (event) => {
		const navigation = performance.getEntriesByType('navigation')[0];
		if ( ! event.persisted && navigation?.type !== 'back_forward' ) return;
		if ( document.querySelector(`.${window.KT_PREFIX || ''}cart-section`) ) {
			window.location.reload();
		}
	});
}

if ( typeof window.syncCartState !== 'function' ) {
	// Applies the cart returned by /cart/change.js. The markup swap is the nice
	// path; this is the one that must not fail, so the counts, the line count and
	// the empty state cannot drift from the real cart.
	window.syncCartState = (cart) => {
		if ( ! cart || typeof cart.item_count !== 'number' ) return;

		const prefix = window.KT_PREFIX || '';

		document.querySelectorAll('[data-cart-count]').forEach(elm=>{
			elm.textContent = cart.item_count;
		});
		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			elm.textContent = cart.item_count;
		});
		document.querySelectorAll(`.${prefix}cart-holder`).forEach(elm=>{
			elm.setAttribute('data-items', cart.items ? cart.items.length : 0);
		});

		const section = document.querySelector(`.${prefix}cart-section`);
		if ( section ) {
			section.classList.toggle(`${prefix}cart-section--empty`, cart.item_count === 0);
		}
	};
}

if ( window.KROWN && KROWN.functions && typeof KROWN.functions.dispatchStandardEvent !== 'function' ) {
	KROWN.functions.dispatchStandardEvent = (className, target, detail) => {
		const SE = window.Shopify && window.Shopify.StandardEvents;
		if ( ! SE || typeof SE[className] !== 'function' ) return;
		try {
			( target || document ).dispatchEvent(new SE[className](detail));
		} catch (error) {
			console.warn(`standard-events: ${className}`, error);
		}
	};
}

if ( ! window.collapseCartItem ) {

	// Collapses a cart line out of the layout so a removal reads as a removal
	// instead of the whole list blinking. Resolves once the row has gone (or
	// straight away when motion is reduced or the transition never fires).
	window.collapseCartItem = (item) => {

		const height = item.getBoundingClientRect().height;
		const prefix = window.KT_PREFIX || '';

		if ( ! height || window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
			item.classList.add(`${prefix}cart-item--collapsed`);
			return Promise.resolve();
		}

		item.style.height = `${height}px`;
		item.style.overflow = 'hidden';
		item.offsetHeight; // flush the start height before transitioning away from it
		item.classList.add(`${prefix}cart-item--collapsing`);
		item.style.height = '0px';

		return new Promise(resolve => {
			let settled = false;
			const finish = () => {
				if ( settled ) return;
				settled = true;
				resolve();
			};
			item.addEventListener('transitionend', (e) => {
				if ( e.target === item && e.propertyName === 'height' ) finish();
			});
			// Never hold the cart refresh hostage to a transition that did not run.
			setTimeout(finish, 450);
		});

	};

}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					// Keep the real href so the link still works without JS.
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					const minQty = parseInt(qty.getAttribute('min')) || 1;
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();

						// There is no zero state in the cart: clearing the field or typing
						// below the minimum snaps back instead of deleting the line. Only
						// the remove control takes a line out.
						let typed = parseInt(qty.value);
						if ( isNaN(typed) || typed < minQty ) {
							typed = minQty;
							qty.value = minQty;
						}

						if ( typed === parseInt(item.dataset.qty) ) return;

						this.updateCartQty(item, typed);
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';

			const isRemoval = newQty === 0;

			// Only a removal locks the row — it is on its way out and its data-line
			// is about to be renumbered. A quantity change must leave the stepper
			// clickable, or the shopper has to wait out a round trip per click.
			if ( item.classList.contains(`${prefix}cart-item--removing`) ) {
				return;
			}

			const subtotal = window.cartSubtotalFor(this);

			item.classList.add(`${prefix}cart-item--${isRemoval ? 'removing' : 'updating'}`);
			if ( subtotal ) {
				subtotal.classList.add(`${prefix}processing`);
			}

			// Start the exit straight away so the click feels answered, and let it
			// play out while the request is in flight rather than after it.
			const collapsed = isRemoval ? window.collapseCartItem(item) : Promise.resolve();
			let cartChanged = false;
			let cartState = null;
			let rendered = false;

			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty,
				// Ask the Cart API to render the refreshed markup in this same
				// response. One request instead of two, and the section is rendered
				// for this exact page — a follow-up GET can be answered for a
				// different URL or theme, which is how the totals ended up stale.
				sections: 'helper-cart',
				sections_url: window.location.pathname
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					cartChanged = response.status != 422;
					if ( cartChanged ) {
						// /cart/change.js answers with the whole updated cart.
						cartState = response;
					}

					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});

						KROWN.functions.dispatchStandardEvent('CartErrorEvent', this, {
							error: alert.textContent
						});
					}
					const section = response.sections && response.sections['helper-cart'];
					if ( section ) return section;

					// Older API behaviour, or a response without the section: fall back
					// to fetching it, still on this page's URL.
					return fetch(window.cartSectionUrl('helper-cart')).then(sectionResponse => {
						if ( ! sectionResponse.ok ) {
							throw new Error(`helper-cart request failed with status ${sectionResponse.status}`);
						}
						return sectionResponse.text();
					});
				})
				.then(text => collapsed.then(() => text))
				.then(text => {

					window.renderHelperCart(text, this);
					rendered = true;

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const updatedItem = this.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

					if ( alert === null ) {
						KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', this, {
							action: newQty === 0 ? 'remove' : 'update',
							context: 'cart',
							lines: [{
								id: item.dataset.id,
								quantity: newQty
							}],
							promise: Promise.resolve({ cart: null })
						});
					}

				})
				.catch(e => {
					console.warn('cart: line update failed', e);

					// Only tell the shopper the cart failed when it actually did. A
					// refresh that fell over after a successful change is handled below.
					if ( ! cartChanged ) {
						const failure = document.createElement('span');
						failure.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						failure.textContent = KROWN.settings.locales.cart_general_error;
						this.form.prepend(failure);
					}
				})
				.finally(() => {
					const subtotalNow = window.cartSubtotalFor(this);
					if ( subtotalNow ) {
						subtotalNow.classList.remove(`${prefix}processing`);
					}
					this.form.classList.remove(`${prefix}processing`);

					if ( cartChanged ) {

						// Counts and the empty state come from the cart the API returned,
						// so they hold even when the markup swap did not happen.
						window.syncCartState(cartState);

						// The refreshed markup normally replaces this row outright; if it
						// is somehow still here, take it out rather than let it flash back.
						if ( isRemoval && item.isConnected ) {
							item.remove();
						}
						item.classList.remove(`${prefix}cart-item--updating`);

						if ( ! rendered ) {
							// Line prices and the totals on screen are now stale and cannot
							// be rebuilt without the section. Reload rather than leave a
							// cart that disagrees with the one being checked out.
							window.location.reload();
						}

						return;
					}

					// The cart did not change — put the row back the way it was.
					item.classList.remove(`${prefix}cart-item--removing`, `${prefix}cart-item--updating`, `${prefix}cart-item--collapsing`, `${prefix}cart-item--collapsed`);
					item.style.removeProperty('height');
					item.style.removeProperty('overflow');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';

			// The stepper writes the new number into the field straight away, so the
			// shopper sees it immediately. Only the request waits, and it waits until
			// they stop clicking: tapping + four times costs one round trip carrying
			// the final quantity, not four that each re-render the row underneath them.
			this.changeCartInput = window.debounce
				? window.debounce(this.commitQuantity.bind(this), 450)
				: this.commitQuantity.bind(this);

			const minus = this.querySelector(`.${this._prefix}qty-minus`);
			const plus = this.querySelector(`.${this._prefix}qty-plus`);
			if ( minus ) minus.addEventListener('click', this.changeCartInput);
			if ( plus ) plus.addEventListener('click', this.changeCartInput);
		}

		commitQuantity(){
			const item = this.closest('[data-js-cart-item]');
			// The row's own cart form — on the cart page in the theme editor the
			// drawer's form is the one getElementById would hand back.
			const cartForm = this.closest('cart-form') || document.getElementById('AjaxCartForm');
			const input = this.querySelector(`.${this._prefix}qty`);

			if ( ! cartForm || typeof cartForm.updateCartQty !== 'function' || ! item || ! input ) {
				// Bailing silently here is how a stepper click goes nowhere with no
				// trace, so say which piece was missing.
				console.warn('cart: cannot commit quantity', {
					cartForm: !!cartForm,
					upgraded: !!cartForm && typeof cartForm.updateCartQty === 'function',
					item: !!item,
					input: !!input
				});
				return;
			}

			// The stepper never empties a line — it stops at the minimum.
			const minQty = parseInt(input.getAttribute('min')) || 1;
			const value = Math.max(minQty, parseInt(input.value) || minQty);
			if ( String(value) !== input.value ) input.value = value;

			if ( value === parseInt(item.dataset.qty) ) return;

			cartForm.updateCartQty(item, value);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}


if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		fetch(window.cartSectionUrl('helper-cart'))
			.then(response => response.text())
			.then(text => {

			window.renderHelperCart(text);

			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(() => {
							KROWN.functions.dispatchStandardEvent('CartNoteUpdateEvent', this, {
								context: 'cart',
								note: event.target.value,
								promise: Promise.resolve({ cart: null })
							});
						});
		  		}, 300)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = this.closest('#AjaxCartSubtotal') || document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.#loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.#handleSuccess();
									} else {
										this.#handleError();
									}
								} else {
									this.#handleError();
								}
							})
							.catch(error => {
								this.#handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			#handleSuccess(){
				fetch(window.cartSectionUrl('helper-cart'))
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = window.renderHelperCart(text, this.closest('cart-form') || (this.cartSubtotal && window.cartScopeFor(this.cartSubtotal).querySelector('cart-form')));

						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						this.cartDiscountError.innerHTML = '';
						this.input.value = '';

						const sectionDiscountCodes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
						if ( this.discountCodes && sectionDiscountCodes ) {
							this.discountCodes.innerHTML = sectionDiscountCodes.innerHTML;
							this.discountCodes.classList.remove(`${this._prefix}processing`);
							this.#loadDiscountButtons();
						}

						const appliedDiscountCodes = sectionDiscountCodes
							? Array.from(sectionDiscountCodes.querySelectorAll('[data-js-discount]')).map(el => ({ code: el.dataset.jsDiscount }))
							: [];
						KROWN.functions.dispatchStandardEvent('CartDiscountUpdateEvent', this, {
							discountCodes: appliedDiscountCodes,
							promise: Promise.resolve({ cart: null })
						});
					})
					.catch(() => this.#handleError())
			}

			#loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.#handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			#handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}
